export default __webpack_public_path__ + "static/assets/947a6530bad18e5d96fe3d3433f2f937.svg";